import './style/bluemateSegmentedToggle.scss';

import React from 'react';

import classNames from 'classnames';

import {BluemateControlShape, BluemateControlSize} from '../../../util/types';

export interface SegmentedToggleOption<T> {
    value: T;
    label: string;
    /** Renders the segment muted and ignores clicks on it; `title` explains why. */
    disabled?: boolean;
    title?: string;
}

interface Props<T extends string> {
    options: Array<SegmentedToggleOption<T>>;
    value: T;
    onChange: (value: T) => void;
    /** Stretch to the container and split it evenly between the segments,
     *  instead of sizing each segment to its label. */
    fullWidth?: boolean;
    /** Rounded-rectangle instead of the default pill. Same vocabulary as the
     *  other controls (BluemateButton, PortalSelect). */
    shape?: BluemateControlShape;
    size?: BluemateControlSize;
    className?: string;
}

export default function BluemateSegmentedToggle<T extends string>(props: Props<T>) {
    const {options, value, onChange, fullWidth, shape = 'rounded', size = 'normal', className} = props;
    return (
        <div
            className={classNames(
                'bluemate-segmented-toggle',
                `shape-${shape}`,
                `size-${size}`,
                fullWidth && 'full-width',
                className
            )}
        >
            {options.map(option => (
                <button
                    key={option.value}
                    className={classNames('segment-btn', value === option.value && 'active', {
                        disabled: option.disabled
                    })}
                    onClick={() => !option.disabled && onChange(option.value)}
                    aria-disabled={option.disabled}
                    title={option.title}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
